import { Link } from "react-router-dom";
import EventSelect from "./event-select/event-select";
import { useEnterEvent } from "../../context/EnterEvent";
import strings from "../../utils/strings";

const Events = () => {
  const { editId } = useEnterEvent();
  return (
    <div className="card shadow-xss w-100 border-0 p-4 mb-3">
      <div className="card-body align-items-center p-0">
        <p className="text-current m-0">
          <strong>Step 2 of 6</strong>{" "}
          {/* {editId ? (
            <strong className="text-red">{strings.event.readonly}</strong>
          ) : null} */}
        </p>
        <p className="m-0 bold">
          {strings.event.select} 
          {/* <Link to="/events">Event PDF</Link>) */}
        </p>

        {editId ? <EventSelect title="Select Domestic Contest" /> : <>
          <EventSelect
            title={<strong>Domestic Contests</strong>}
            heading="Domestic Contests"
            type="isDomestic"
          />
          <EventSelect
            title={<strong>International Contests</strong>}
            heading="International Contests"
            type="isInternational"
          />
          <EventSelect
            title={
              <>
                <strong>General Events</strong>{" "}
                <span className="event-select-note">
                  &nbsp; (No Premium Membership Required)
                </span>
              </>
            }
            heading="General Events"
            type="isFree"
          />
        </>}


      </div>
    </div>
  );
};

export default Events;
